export default {"src":"/_next/static/media/worldwideAcceptance.0a23bcc6.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};